import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import { useRouter } from "next/router";
import React from "react";
import { MdSearch } from "react-icons/md";

import styles from "./index.module.scss";

import { useBusyCount } from "@/modules/common-hooks/useBusyCount";
import {
  getLinkToPageExploreAssets,
  getLinkToPageGalleryArtwork,
  getLinkToPagePolicy,
} from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export default function SearchBar({ className, style }: Props) {
  const { busy, withDefaultErrorHandler } = useBusyCount();
  const router = useRouter();
  const [searchQuery, setSearchQuery] = React.useState(
    typeof router.query.q === "string" ? router.query.q : ""
  );

  const handleSubmit = withDefaultErrorHandler(async (searchQuery: string) => {
    searchQuery = searchQuery.trim();
    if (searchQuery.startsWith("asset1")) {
      await router.push(getLinkToPageGalleryArtwork(searchQuery, "info"));
    } else if (/^[0-9a-f]{56}$/.test(searchQuery)) {
      await router.push(getLinkToPagePolicy(searchQuery));
    } else if (/^[0-9a-f]{57,}$/.test(searchQuery)) {
      await router.push(getLinkToPageGalleryArtwork(searchQuery, "info"));
    } else {
      await router.push(getLinkToPageExploreAssets(searchQuery));
    }
  });

  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Row
        gap="16px"
        padding="4px 20px"
        minHeight="48px"
        alignItems="center"
        boxSizing="border-box"
      >
        <Flex.Row flex="0 0 auto">
          <MdSearch size="24px" />
        </Flex.Row>
        <Flex.Cell asChild flex="1 1 auto" minWidth="0">
          <input
            className={styles.input}
            value={searchQuery}
            placeholder="Search assets & policies"
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter" && searchQuery) {
                handleSubmit(searchQuery);
              }
            }}
            disabled={busy}
          />
        </Flex.Cell>
      </Flex.Row>
    </div>
  );
}
